import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd148a0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column vh-100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"modal fade\" id=\"myModal\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\" data-v-bd148a0c><div class=\"modal-dialog modal-lg\" data-v-bd148a0c><div class=\"modal-content\" data-v-bd148a0c><div class=\"modal-body\" data-v-bd148a0c><iframe class=\"iframeModal\" id=\"yourIframeId\" src=\"https://tri-m.app/ormari/modal.php\" data-v-bd148a0c></iframe><iframe class=\"iframeModalAcc\" id=\"accIframe\" src=\"https://tri-m.app/ecabinet/index.php\" data-v-bd148a0c></iframe></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBarComponent = _resolveComponent("NavBarComponent")!
  const _component_NavComponent = _resolveComponent("NavComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((_ctx.$store.state.requiresAuth === 2 || _ctx.$store.state.requiresAuth === 3))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_NavBarComponent)
        ]))
      : _createCommentVNode("", true),
    ((_ctx.$store.state.requiresAuth === 2))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_NavComponent),
          _hoisted_4,
          _createVNode(_component_FooterComponent)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.fullPath
    }))
  ]))
}